<template>
  <div>
    <h3 style="display:inline;">
      {{ article.title }}
    </h3>
    <div
      style="font-size: 18px; color: #555;"
      v-html="article.preview"
    />
    <hr>
    <div
      style="font-size: 18px; color: #555;"
      v-html="article.content"
    />
    <div class="row justify-content-md-center">
      <b-carousel
        class="col"
        style="max-width: 720px"
        v-if="images.length > 0"
        id="carousel-1"
        :interval="4000"
        controls
        indicators
        background="#"
      >
        <b-carousel-slide
          v-for="image in images"
          :key="image.id"
          :caption="image.name"
          :text="image.description"
          :img-src="image.url"
        />
      </b-carousel>
    </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Article',
  data () {
    return {
      articleId: parseInt(this.$route.params.id)
    }
  },
  computed: {
    ...mapGetters([
      'getStoredArticleById'
    ]),
    article () {
      return this.getStoredArticleById(this.articleId)
    },
    images () {
      if (this.article.slider == null) return []
      return JSON.parse(this.article.slider)
    }
  },
  mounted () {
    this.getArticleById(this.articleId)
  },
  methods: {
    ...mapActions([
      'getArticleById'
    ])
  }
}
</script>

<style scoped>
.article-border {
  border: 1px solid black;
}
</style>

<style>

.carousel-caption {
  position: relative;
  left: 0;
  top: 0;
  color: black;
}
</style>
